export enum FormFieldConditionActionType {
  Visibility = 0,
  Requirement = 1
}
